/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Broad_Inner_Lynx_TalkInputs */

const fr_broad_inner_lynx_talk = /** @type {(inputs: Broad_Inner_Lynx_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement`)
};

/**

* @param {Broad_Inner_Lynx_TalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const broad_inner_lynx_talk = /** @type {((inputs?: Broad_Inner_Lynx_TalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Broad_Inner_Lynx_TalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_broad_inner_lynx_talk(inputs)
});